<template>
  <VueDPlayer ref="player" class="v-d-player" :options="options"/>
</template>

<script>
import VueDPlayer from 'vue-dplayer'
import 'vue-dplayer/dist/vue-dplayer.css'

export default {
  name: 'DPlayer',
  components: {
    VueDPlayer,
  },
  props: {
    url: {
      type: String,
      required: true,
    },
    volume: {
      type: Number,
      default: 0.7,
    },
  },
  data () {
    return {
      options: {
        autoplay: false,
        theme: '#fadfa3',
        loop: false,
        screenshot: false,
        hotkey: false,
        preload: 'auto',
        mutex: true,
      },
    }
  },
  watch: {
    url: {
      handler (val) {
        this.$nextTick(() => {
          this.$refs.player.dp.switchVideo({ url: val })
          this.$refs.player.dp.video.load()
        })
      },
      immediate: true,
    },
  },
  mounted () {
    this.reset()
    this.$refs.player.dp.volume(this.volume, true, true)
    this.$refs.player.dp.on('canplay', () => this.$refs.player.dp.play())
  },
  methods: {
    reset () {
      const setting = this.$refs.player.$el.querySelector('.dplayer-controller .dplayer-setting')
      setting.style.display = 'none'
    },
  },
}
</script>

<style lang="scss" scoped>
.v-d-player {
  font-size: 0.1rem;
}
</style>
